<template>
<div>
  <v-tabs
    color="secondary"
    dark
    next-icon="arrow_forward_ios"
    prev-icon="arrow_back_ios"
    show-arrows
  >
   <v-tabs-slider color="white"></v-tabs-slider>
    <template v-for="(tab, i) in tabs" >
      <v-tab @click="way = tab.path" v-if="tab.enable" :key="'tab_'+i">
        <img :src="tab.icon" :width="20"/>
        &nbsp; &nbsp;{{tab.name}}
      </v-tab>
    </template>
    </v-tabs>
    <Recharge v-show="way=='recharge'"/>
    <PostPaid v-show="way=='postpaid'"/>
    <Dish v-show="way=='dish'"/>
    <FOS v-if="way == 'fos'"/>
    <Pay v-show="way=='pay'"/>
    <div v-show="way=='broadband'">
      <BHIMBroadBand v-if="bhim"/>      
      <BroadBand v-else/>      
    </div>
    <div  v-show="way=='electricity'">
      <BHIMElectricity v-if="bhim"/>
      <Electricity v-else/>
    </div>
    <div v-show="way=='gas'">
      <BHIMGas v-if="bhim"/>
      <Gas v-else/>
    </div>
    <div  v-show="way=='landline'">
      <BHIMLandline v-if="bhim"/>
      <Landline v-else/>
    </div>
    <div v-show="way=='water'">
      <BHIMWater v-if="bhim"/>
      <Water v-else/>
    </div>
    <v-dialog
                v-model="dialog"
                persistent
                width="300">
                        <v-card
                        color="primary"
                        dark>
                                <v-card-text>Please wait
                                        <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                        />

                        </v-card-text>
                </v-card>
                 </v-dialog>

 </div>
</template>
<script>
import Recharge from '../home/Recharge.vue'
import PostPaid from '../home/PostPaid.vue'
import Dish from '../home/Dish.vue'
import Pay from '../home/Pay.vue'
import BroadBand from '../home/Broadband.vue'
import Electricity from '../home/Electricity.vue'
import Gas from '../home/Gas.vue'
import Landline from '../home/Landline.vue'
import Water from '../home/Water.vue'
import FOS from "../home/FOS.vue";
import BHIMBroadBand from '../bhim/Broadband.vue'
import BHIMElectricity from '../bhim/Electricity.vue'
import BHIMGas from '../bhim/Gas.vue'
import BHIMLandline from '../bhim/Landline.vue'
import BHIMWater from '../bhim/Water.vue'


export default {
    data(){
        return{
          way:'recharge',
          dialog : false,
          tabs: [{
              path: 'recharge',
              name: "Recharge",
              icon: require('../assets/smartphone.svg'),
              enable: true
            },
            {
              path: 'postpaid',
              name: "Post Paid",
              icon: require('../assets/smartphone.svg'),
              enable: true
            },
            {
              path: 'fos',
              name: "FOS",
              icon: require('../assets/smartphone.svg'),
              enable: false
            },
            {
              path: 'dish',
              name: "Dish",
              icon: require('../assets/dish.svg'),
              enable: true
            },
            {
              path: 'pay',
              name: "Pay",
              icon: require('../assets/pay.svg'),
              enable: true
            },
            {
              path: 'broadband',
              name: "broadband",
              icon: require('../assets/router.svg'),
              enable: true
            },
            {
              path: "electricity",
              name: "electricity",
              icon: require('../assets/lamp.svg'),
              enable: true
            },
            {
              path: "gas",
              name: "gas",
              icon: require('../assets/gas.svg'),
              enable: true
            },
            {
              path: "landline",
              name: "land line",
              icon: require('../assets/landline.svg'),
              enable: true
            },
            {
              path: 'water',
              name: "water",
              icon: require('../assets/tap.svg'),
              enable: false
            },
            ]
        }
    },
    computed: {
      bhim() {
        return this.$store.getters.bhim;
      }
    },
    components:{
        Recharge,
        PostPaid,
        Dish,
        Pay,
        BroadBand,
        Electricity,
        Gas,
        Landline,
        Water,
        BHIMBroadBand,
        BHIMElectricity,
        BHIMGas,
        BHIMLandline,
        BHIMWater,
        FOS
    },
    mounted(){
      let vm = this;
    }
}
</script>


<style>
.v-tabs__icon--next{
    top:12px!important;
}
.v-tabs__icon--prev{
    top:10px!important;
}

</style>
